import axios from 'axios'

export const CustomerServiceApi = (data, ipEl, caseFormEl, setErrors, createServerServiceSchema, setSubmitting ) => {
  axios
    .post(`${process.env.GATSBY_API_ENDPOINT}/Contact/Service`, data)
    .then(response => {
      const result = response.data.Result

      if (response !== null && result !== null && result === true) {
        axios
          .get(process.env.GATSBY_NETLIFY_CLIENTIP)
          .then(response => {
            const clientIp = response.data
            ipEl.current.value = clientIp
          })
          .then(() => {
            // Disable post to salesforce and redirect to thankyoupage.
            //caseFormEl.current.submit()
            window.location.href=`${process.env.GATSBY_SITE_URL}/confirm-support`
          })
      } else {
        setErrors(
          createServerServiceSchema(
            response.data,
            caseFormEl.current
          )
        )
      }
    })
    .catch(error => {
      alert(error)
    })
    .then(() => {
      setSubmitting(false)
    })   
}

export const SalesApi = (data, ipEl, salesFormEl, setErrors, createServerLeadSchema, setSubmitting) => {
  axios
    .post(`${process.env.GATSBY_API_ENDPOINT}/Contact/Sales`, data)
    .then(response => {
      const result = response.data.Result

      if (response !== null && result !== null && result === true) {
        axios
          .get(process.env.GATSBY_NETLIFY_CLIENTIP)
          .then(response => {
            const clientIp = response.data
            ipEl.current.value = clientIp
          })
          .then(() => {
            // disable post to salesforce and redirect to thankyou page.
            //salesFormEl.current.submit()
            window.location.href=`${process.env.GATSBY_SITE_URL}/confirm-sales?src=contactsales`
          })
      } else {
        setErrors(
          createServerLeadSchema(
            response.data,
            salesFormEl.current
          )
        )
      }
    })
    .catch(error => {
      alert(error)
    })
    .then(() => {
      setSubmitting(false)
    })
}